module.exports = __webpack_public_path__ + "static/media/wikipedia.8154f969.JPG";